export default __webpack_public_path__ + "static/content3-58827c8dbf02e386285ebaf1368acbff.png";